import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Check if token is expired by decoding the JWT payload
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('authToken');
      return <Navigate to="/login" replace />;
    }
  } catch {
    // If token can't be decoded, it's invalid
    localStorage.removeItem('authToken');
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;